import React, { useContext } from 'react';
import { Empty, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import MonetaryConverter from '../../../helpers/monetaryConverter';
import './list.css';
import { Context } from '../../../context/AuthContext';

function List(props) {
    const { userData } = useContext(Context);
    const { salesGoals, selectSalesGoal } = props;

    return (
        <>
            <div className="sales-goals-header">
                <div className="sales-goals-header-item month"><span>Mês</span></div>
                <div className="sales-goals-header-item company"><span>Empresa</span></div>
                <div className="sales-goals-header-item value"><span>Valor</span></div>
                <div className="sales-goals-header-item effective-date"><span>Data Vigência</span></div>
                <div className="sales-goals-header-item operator"><span>Operadora</span></div>
                <div className="sales-goals-header-item client-payment"><span>Pgto Cliente</span></div>
                <div className="sales-goals-header-item commission-percent"><span>%</span></div>
                <div className="sales-goals-header-item commission-payment"><span>Comissão</span></div>
                <div className="sales-goals-header-item contract-bonus"><span>Tempo Contrato</span></div>
                <div className="sales-goals-header-item listing"><span>Listagem</span></div>
                <div className="sales-goals-header-item edit"><span>Editar</span></div>
            </div>

            {salesGoals.length == 0
                ? <Empty description="Nenhum resultado." style={{ marginTop: "50px" }} />
                : salesGoals.map((sg) => (
                    <div className="sales-goal-row" key={sg._id}>
                        <div className="sales-goal-item month">
                            <span>{sg.month}</span>
                        </div>
                        <div className="sales-goal-item company">
                            <span className="company-name">{sg.company}</span>
                        </div>
                        <div className="sales-goal-item value">
                            {sg.value
                                ? <MonetaryConverter quantity={sg.value} class="plan-price" />
                                : <span>-</span>
                            }
                        </div>
                        <div className="sales-goal-item effective-date">
                            <span>{sg.effectiveDate || '-'}</span>
                        </div>
                        <div className="sales-goal-item operator">
                            <span>{sg.operator ? sg.operator.name : '-'}</span>
                        </div>
                        <div className="sales-goal-item client-payment">
                            <span>{sg.clientPayment || '-'}</span>
                        </div>
                        <div className="sales-goal-item commission-percent">
                            <span>{sg.commissionPercent ? `${sg.commissionPercent}%` : '-'}</span>
                        </div>
                        <div className="sales-goal-item commission-payment">
                            <span>{sg.commissionPayment || '-'}</span>
                        </div>
                        <div className="sales-goal-item contract-bonus">
                            <span>{sg.contractBonus || '-'}</span>
                        </div>
                        <div className="sales-goal-item listing">
                            <span>{sg.listing || '-'}</span>
                        </div>
                        <div className="sales-goal-item edit">
                            <Button type="default" shape="circle" icon={<EditOutlined />} size="small" onClick={() => selectSalesGoal(sg._id)} />
                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default List;
